import Payment from 'payment';

const visaRegex = /^4[0-9]{12}(?:[0-9]{3})?$/;

export const getCreditCardType = (number: string | number): string => {
  const strNumber = `${number}`;
  if (visaRegex.test(strNumber.split(' ').join(''))) return 'Visa';
  return Payment.fns.cardType(strNumber);
};
